(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discovery-snack-box-pair"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-discovery-pair]').forEach(root=>{
 const button=root.querySelector('[data-pair-spin]');
 const candidates=Array.from(root.querySelectorAll('[data-pair-candidates] a')).filter((item,index,list)=>list.findIndex(other=>other.dataset.productHandle===item.dataset.productHandle)===index);
 if(!candidates.length){button.hidden=true;return;}
 let previous=-1;
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 button.addEventListener('click',()=>{
  let choice=Math.floor(Math.random()*candidates.length);
  if(candidates.length>1&&choice===previous)choice=(choice+1)%candidates.length;
  previous=choice;
  const label=button.innerHTML;
  const panel=root.querySelector('.ps-discovery-pair__globe-panel');
  button.disabled=true;button.textContent=button.dataset.spinningLabel;panel.classList.add('is-spinning');
  window.setTimeout(()=>{
   const result=root.querySelector('[data-pair-result]');
   result.replaceChildren(candidates[choice].cloneNode(true));result.hidden=false;
   button.disabled=false;button.innerHTML=label;panel.classList.remove('is-spinning');
  },reduced.matches?0:1100);
 });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snack-lore-signup"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (scope) => scope.querySelectorAll('[data-snack-lore-signup]').forEach((config) => {
    const form = config.closest('form');
    if (!form || form.dataset.loreSignupReady) return;
    form.dataset.loreSignupReady = 'true';
    let pending = false;
    let savedEmail = '';
    form.addEventListener('submit', async (event) => {
      const email = form.elements['contact[email]'].value.trim();
      if (savedEmail === email) return;
      event.preventDefault();
      if (pending || !form.reportValidity()) return;
      const error = form.querySelector('[data-lore-signup-error]');
      pending = true;
      error.hidden = true;
      const button = form.querySelector('button[type="submit"]');
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      try {
        const properties = {signup_source:'Snack Lore', snack_lore_entry_url:config.dataset.entryUrl, snack_lore_entry_title:config.dataset.entryTitle};
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(config.dataset.company)}`, {
          method:'POST',
          headers:{accept:'application/vnd.api+json','content-type':'application/vnd.api+json',revision:'2026-07-15'},
          body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Pop Snax Snack Lore',profile:{data:{type:'profile',attributes:{email,properties,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:config.dataset.list}}}}}),
          signal:AbortSignal.timeout(15000)
        });
        if (!response.ok) throw new Error('Signup failed');
        savedEmail = email;
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', {$email:email,...properties}]);
        window._learnq.push(['track','Snack Lore Signup',{entry_url:config.dataset.entryUrl}]);
        button.disabled = false;
        form.requestSubmit(button);
      } catch (failure) {
        error.textContent = config.dataset.error;
        error.hidden = false;
      } finally {
        pending = false;
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snack-vote-signup"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (scope) => scope.querySelectorAll('[data-snack-vote-signup]').forEach((config) => {
    const form = config.closest('form');
    if (!form || form.dataset.voteSignupReady) return;
    form.dataset.voteSignupReady = 'true';
    let pending = false;
    let savedEmail = '';
    let savedPick = '';
    form.addEventListener('submit', async (event) => {
      const email = form.elements['contact[email]'].value.trim();
      const mode = config.dataset.snackVoteSignup;
      const selected = mode === 'country' ? form.querySelector('input[name="contact[Requested country]"]:checked') : null;
      const other = form.elements['contact[Other country]']?.value.trim();
      const pick = mode === 'brand' ? form.elements['contact[Requested brand]'].value.trim() : selected?.value === 'Other' ? other : selected?.value;
      if (savedEmail === email && savedPick === pick) return;
      event.preventDefault();
      if (pending || !form.reportValidity()) return;
      const error = form.querySelector('[data-vote-signup-error]');
      if (!pick) {
        error.textContent = config.dataset.error;
        error.hidden = false;
        return;
      }
      pending = true;
      error.hidden = true;
      const button = form.querySelector('button[type="submit"]');
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      try {
        const properties = {[mode === 'brand' ? 'requested_brand' : 'requested_country']:pick, snack_suggestion_source:mode, snack_suggestion_updated_at:new Date().toISOString()};
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(config.dataset.company)}`, {
          method:'POST',
          headers:{accept:'application/vnd.api+json','content-type':'application/vnd.api+json',revision:'2026-07-15'},
          body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:`Pop Snax Shop by ${mode === 'brand' ? 'Brand' : 'Country'} suggestion`,profile:{data:{type:'profile',attributes:{email,properties,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:config.dataset.list}}}}}),
          signal:AbortSignal.timeout(15000)
        });
        if (!response.ok) throw new Error('Signup failed');
        savedEmail = email;
        savedPick = pick;
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', {$email:email,...properties}]);
        window._learnq.push(['track','Snack Suggestion Submitted',{suggestion_type:mode,suggestion:pick}]);
        button.disabled = false;
        form.requestSubmit(button);
      } catch (failure) {
        error.textContent = config.dataset.error;
        error.hidden = false;
      } finally {
        pending = false;
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
